
<script>
import {Vue, Watch, Prop} from 'vue-property-decorator';
import {formatTimeNumber, isAvailable} from './util';
import scrollIntoView from 'scroll-into-view-if-needed';
import {Options} from 'vue-class-component';

@Options({
    emits: ['change'],
    name: 'zt-time-piker'
})
export default class TimePicker extends Vue {

    hour = '';
    minute = '';

    @Prop({type: String, default: ''}) title;
    @Prop({type: Date}) value;
    @Prop({type: Date}) minTime;
    @Prop({type: Date}) maxTime;
    @Prop({type: Boolean, default: false}) allowAddEndMinute;
    @Prop({type: Boolean, default: false}) disabled;

    created() {
        this.resetValues();
    }

    resetValues() {
        if (this.value) {
            this.hour = this.value.getHours();
            this.minute = this.value.getMinutes();
            
        } else {
            this.hour = '';
            this.minute = '';
        }
    }

    srcollValueIntoCenter(animation) {
        this.srcollIntoCenter(this.$refs[`hour-${this.hour}`], this.$refs['hour-wrapper'], animation);
        this.srcollIntoCenter(this.$refs[`minute-${this.minute}`], this.$refs['minute-wrapper'], animation);
    }

    @Watch('value')
    propValueChange(newVal) {
        this.resetValues();
    }

    getHours() {
        const hours = [];
        for (let i = 0; i <= 23; i++) {
            hours.push(i);
        }
        return hours;
    }

    @Watch('watchValue')
    valueChange() {
        const { hour, minute } = this;
        if (hour !== '' || minute !== '') {
            const v = new Date();
            v.setHours(hour);
            v.setMinutes(minute);
            this.$emit('change', v);
        }
    }

    get watchValue() {
        return this.hour + ':' + this.minute;
    }

    getMinutes() {
        const minutes = [];
        for (let i = 0; i < 60; i = i + 5) {
            minutes.push(i);
        }
        return minutes;
    }

    srcollIntoCenter(node, boundary, animation = true) {
        if (node) {
            scrollIntoView(node, {
                behavior: animation ? 'smooth' : 'instant',
                block: 'start',
                boundary: boundary
            });
        }
    }

    hourItemClick(hourItem, e) {
        if (hourItem !== this.hour) {
            this.hour = hourItem;
            this.minute = 0;
            this.$nextTick(() => {
                this.srcollValueIntoCenter(true);
            })
        }
    }

    minutesItemClick(minuteItem, e) {
        if (this.minute !== minuteItem) {
            this.minute = minuteItem;
            this.$nextTick(() => {
                this.srcollValueIntoCenter(true);
            })
        }
    }

    render() {
        const { title, hour, minute, minTime, maxTime, allowAddEndMinute, disabled } = this;
        const hours = this.getHours();
        const minutes = this.getMinutes();
        const maxHour = maxTime && maxTime.getHours();
        const minHour = minTime && minTime.getHours();
        const maxMinute = maxTime && maxTime.getMinutes();
        const minMinute = minTime && minTime.getMinutes();
        if (allowAddEndMinute && hour === 23) {
            minutes.push(59);
        }
        return <div class="zt-time-picker">
            <div class="zt-time-picker-title">{title}</div>
            <div class="zt-time-picker-select">
                <div class="zt-time-picker-select-hours" ref="hour-wrapper">
                    <ul class="zt-time-picker-select-hours-wrapper">
                        {
                            hours.map((hourItem, i) => {
                                const hourDisabled = !(
                                    (isAvailable(maxHour) && hourItem <= maxHour || !isAvailable(maxHour))
                                    && (isAvailable(minHour) &&  hourItem >= minHour || !isAvailable(minHour))
                                ) || (isAvailable(maxHour) && isAvailable(maxMinute) && maxHour == hourItem && minutes.findIndex(v => v == maxMinute) === 0)
                                || (isAvailable(minHour) && isAvailable(minMinute) && minHour == hourItem && minutes.findIndex(v => v == minMinute) === minutes.length - 1)
                                || disabled;
                                return <li ref={`hour-${hourItem}`} onClick={!hourDisabled && this.hourItemClick.bind(this, hourItem) || (() => {})} class={['time-select-item', {
                                    'disabled': hourDisabled,
                                    'is-active': hour === hourItem
                                }]} key={hourItem}>
                                    {formatTimeNumber(hourItem)}
                                </li>
                            })
                        }
                    </ul>
                </div>
                <div class="zt-time-picker-select-minutes" ref="minute-wrapper">
                    <ul class="zt-time-picker-select-minutes-wrapper">
                        {
                            minutes.map((minuteItem, i) => {
                                const max = new Date();
                                max.setHours(maxHour);
                                max.setMinutes(maxMinute);
                                const min = new Date();
                                min.setHours(minHour);
                                min.setMinutes(minMinute);
                                const current = new Date();
                                current.setHours(hour);
                                current.setMinutes(minuteItem);

                                const timestamp = current.getTime();
                                const maxTimestamp = max.getTime();
                                const minTimestamp = min.getTime();
                                let minDisabled = !(
                                    (maxMinute !== undefined && timestamp < maxTimestamp || maxMinute === undefined)
                                    && (minMinute !== undefined && timestamp > minTimestamp || minMinute === undefined)
                                ) || disabled;
                                return <li ref={`minute-${minuteItem}`} onClick={!minDisabled && this.minutesItemClick.bind(this, minuteItem) || (() => {})} class={['time-select-item', {
                                    'disabled': minDisabled,
                                    'is-active': minute === minuteItem
                                }]} key={minuteItem}>
                                    {formatTimeNumber(minuteItem)}
                                </li>
                            })
                        }
                    </ul>
                </div>
            </div>
        </div>
    }
}
</script>

<style lang="scss">
@import './var.scss';

.zt-time-picker {
    min-width: 100px;
    position: relative;
    &-title {
        text-align: center;
        padding: 8px 5px;
        border-bottom: 1px solid $border-base-color;
        font-size: 12px;
        line-height: 16px;
        box-sizing: border-box;
        color: $text-primary-color;
        height: 34px;
    }

    &-select {
        display: flex;
        &-hours, &-minutes {
            width: 50%;
            max-height: 200px;
            overflow: hidden;
            text-align: center;
            padding: 5px 0;
            // border-right: 1px solid transparent;
            &:hover {
                overflow-y: auto;
            }
            &-wrapper {
                margin: 0;
                padding-left: 0;
                padding-bottom: 177px;
                .time-select-item {
                    // width: 53.5px;
                    box-sizing: border-box;
                    padding: 4px 0;
                    margin: 0;
                    list-style: none;
                    font-size: 12px;
                    color: $text-primary-color;
                    text-align: center;
                    &.is-active {
                        // background-color: #f5f7fa;
                        color: $primary-color;
                        font-weight: bold;
                    }
                    &:hover {
                        color: #fff;
                        background-color: $primary-color;
                    }
                    &.disabled {
                        color:  $disabled-color;
                        cursor: not-allowed;
                    }
                    
                }
            }

        }

        &-minutes {
            border-right: none;
        }
    }
    
}

</style>
